import React from 'react';

import ContentWithBackButton from 'components/PageLayout/ContentWithBackButton';

import styles from './PoliciesPage.module.scss';

const OnlinePrivacyPolicy = () => {
  const linkedInPolicyLink = (
    <a
      href="https://www.linkedin.com/legal/privacy-policy"
      rel="noopener noreferrer"
      target="_blank"
    >
      LinkedIn Privacy Policy
    </a>
  );
  const facebookPolicyLink = (
    <a href="https://www.facebook.com/privacy/policy/" rel="noopener noreferrer" target="_blank">
      Facebook Privacy Policy
    </a>
  );
  const instagramPolicyLink = (
    <a href="https://privacycenter.instagram.com/policy/" rel="noopener noreferrer" target="_blank">
      Instagram Privacy Policy
    </a>
  );
  const mainSiteLink = (
    <a href="https://www.heightsfinance.com" rel="noopener noreferrer" target="_blank">
      {' '}
      www.heightsfinance.com
    </a>
  );
  const loanSiteLink = (
    <a href="https://loan.heightsfinance.com" rel="noopener noreferrer" target="_blank">
      loan.heightsfinance.com
    </a>
  );
  const accountSiteLink = (
    <a href="https://myaccount.heightsfinance.com" rel="noopener noreferrer" target="_blank">
      myaccount.heightsfinance.com
    </a>
  );

  const privacyNoticeLink = (title: string) => {
    return (
      <a
        target="_blank"
        href="https://heightsfinance.com/pdf/Apr.%202025%20Heights%20Privacy%20Notice%20(FINAL).pdf"
      >
        {title}
      </a>
    );
  };

  const renderContent = () => {
    return (
      <div className={styles.consentContent}>
        <p>
          Your privacy is important to Heights Finance Holding Co. and its subsidiaries (“Heights
          Finance”) so we’ve developed this Online Privacy Policy that covers how we collect, use,
          disclose, transfer and store information received about you during visits to our websites,
          which include but are not limited to {mainSiteLink}, {loanSiteLink}, and {accountSiteLink}{' '}
          (collectively, “Site”). This Online Privacy Policy supplements our Privacy Notice.
        </p>
        <p>
          For a copy of our Privacy Notice, click {privacyNoticeLink('here')} or contact us at{' '}
          <a href={'tel: +1-866-413-1836'}>1-866-413-1836</a> to request a copy.
        </p>
        <p>
          By accessing or using the Site, you acknowledge that you have read, understand, and agree
          to the terms of this Online Privacy Policy. If you cannot agree to the Online Privacy
          Policy please do not use the Site.
        </p>
        <p className={styles.contentSubtitle}>Types of Information Collected</p>
        <p>
          We collect information from a variety of sources, including information provided by you,
          information we collect when you visit our Site, and information we collect about you from
          third party sources. For example, we may collect information such as your screen
          resolution, browser type, referring and exit pages, operating system, internet protocol
          (IP) addresses, internet service provider (ISP), date/time stamp, language, zip code, area
          code, location, and time zone, as well as behavioral data, including mouse movements,
          touch screen inputs, keystroke and key pressed data. We collect this information so that
          we can better understand customer behavior and improve our products, services, and
          advertising, as well as for fraud prevention. Heights Finance may use this information in
          our marketing and advertising services.
        </p>
        <p>
          We may collect, use, transfer, and disclose non-personal information for any purpose. If
          we combine non-personal information with personal information collected through
          application process or other means, the combined information will be treated as personal
          information for as long as it remains combined. For more information regarding how we
          collect, store and use personal information, see our {privacyNoticeLink('Privacy Notice')}
          .
        </p>
        <p className={styles.contentSubtitle}>Cookies and Other Technologies</p>
        <p>
          The Site, email messages, and advertisements may use “cookies”, pixel tags, web beacons
          and other tracking technologies. These technologies help us better understand user
          behavior, tell us which parts of our Site people have visited, and allow repeat visitors
          to be served more quickly and efficiently. You can refuse to accept cookies on most
          browsers and devices through their own privacy settings. You will need to manage these
          settings yourself. If you refuse to accept the cookies, you may experience some
          inconvenience in your use of the Site. For example, the Site will not recognize your
          device. You also may not receive tailored advertising or special offers based on your
          browsing history.
        </p>
        <p>
          We may use a “click-through URL” linked to content on the Site. When customers click one
          of these URLs, they pass through a separate web server before arriving at the destination
          page on our website. We track this click-through data to help us determine interest in
          particular topics and measure the effectiveness of our customer communications. If you
          prefer not to be tracked in this way, you should not click text or graphic links in the
          email messages.
        </p>
        <p>
          Pixel tags enable us to send email messages in a format customers can read, and they tell
          us whether mail has been opened. We may use this information to change the frequency of
          messages sent to customers.
        </p>
        <p>
          <span>Google Analytics</span>
          <p>
            We use Google Analytics, a web analytics service provided by Google, Inc. Google
            Analytics uses cookies or other tracking technologies to help us analyze how users
            interact with the Site, compile reports on the Site’s activity, and provide other
            services related to Site activity and usage. The technologies used by Google may collect
            information such as your IP address, time of visit, whether you are a returning visitor,
            and any referring website. The technologies used by Google Analytics do not gather
            information that personally identifies you.  The information generated by Google
            Analytics will be transmitted to and stored by Google and will be subject to Google’s
            privacy policies.  To learn more about Google’s partner services and to learn how to
            opt-out of tracking of analytics by Google,{' '}
            <a
              href="https://tools.google.com/dlpage/gaoptout"
              target="_blank"
              rel="noopener noreferrer"
            >
              click here
            </a>
            .
          </p>
        </p>

        <p>
          <span>Online Tracking</span>
          <p>
            We partner with companies that deliver ads for our Sites that you visit on the web. In
            order to provide you with a more appropriate online experience, some of our ads that you
            may see are based on your previous online activity on our Site and other websites.
            Information about your online activities, combined with other information, may be used
            to select an ad for a product or service that better matches your interests - which is
            called online behavioral advertising (OBA) or interest-based advertising.
          </p>
        </p>
        <p>
          You can opt out from receiving ads based on your online behavior either by visiting the
          Digital Advertising Alliance (DAA) opt out page at{' '}
          <a href="http://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer">
            http://www.aboutads.info/choices/
          </a>
          . If you elect to opt out of OBA, you will still see ads, but they may not be as pertinent
          to you. Please keep in mind that opting out is cookie-based and will only affect the
          specific computer and browser on which the opt-out cookie is applied. If you delete your
          browser cookies or if you use a different computer or a different browser and want to
          continue to be opted out of OBA, you will need to opt out again.
        </p>
        <p>
          <span>How We Respond to Do Not Track Signals</span>
          <p>
            Our Site does not currently have the capability to recognize the various Do Not Track
            signals or mechanisms from different web browsers. For more information on Do Not Track
            please visit{' '}
            <a href="https://allaboutdnt.com" target="_blank" rel="noopener noreferrer">
              https://allaboutdnt.com
            </a>
            .
          </p>
        </p>
        <p className={styles.contentSubtitle}>Disclosure of Information Through Third Parties</p>
        <p>
          Heights Finance may allow third parties such as social media companies share buttons
          (widgets) on the Site to allow you to share information from the Site on another platform.
          The third parties that own these widgets, including LinkedIn®, Facebook®, and Instagram®,
          may have access to your browsing history on the Site. Please consult these third party
          sites, including {linkedInPolicyLink}, {facebookPolicyLink}, and {instagramPolicyLink},
          for information regarding how this information is collected and used. We are not
          responsible for the privacy policies or practices of linked third party sites or services.
        </p>
        <p className={styles.contentSubtitle}>Disclosures Permitted by Law</p>
        <p>
          Heights Finance may disclose all of the nonpublic personal information described above, as
          permitted by law. For example, we may use affiliated and nonaffiliated parties to perform
          services for us, such as providing customer assistance, handling claims, protecting
          against fraud and maintaining software for us. We also may disclose information in
          response to requests from law enforcement agencies, state insurance or financial
          authorities, or legal subpoenas.
        </p>
        <p className={styles.contentSubtitle}>Nonpublic Personal Information</p>
        <p>
          Heights Finance does not disclose nonpublic personal information about customers or former
          customers or customers except in accordance with our {privacyNoticeLink('Privacy Notice')}
          .
        </p>
        <p className={styles.contentSubtitle}>Security</p>
        <p>
          To prevent unauthorized access to your personal data, maintain data accuracy, and ensure
          the correct use of information, Heights Finance follows generally accepted industry
          standards to protect the personal information submitted to us both during transmission and
          once we receive it. No method of transmission of data over the internet or method of
          electronic storage is 100% secure, and therefore, although we strive to use commercially
          acceptable means to protect your data we cannot guarantee its absolute security.
        </p>
        <p>
          <span>Data Retention</span>
          <p>
            The data collected will be retained as necessary to perform our services through our
            Site and for a reasonable period of time afterward. Please be aware that some or all of
            the data retained by us may be necessary for the Site to function properly.
          </p>
        </p>
        <p className={styles.contentSubtitle}>Third Party Site Links</p>
        <p>
          The Site may contain links to third party websites where personal information is collected
          and used. Your visit to any third party website is governed by the privacy policy and
          terms of use applicable to that site. We are not responsible for the privacy policies or
          practices of linked third party sites or services.
        </p>
        <p className={styles.contentSubtitle}>Children</p>
        <p>
          The Site is intended for the use of adults who are actual or potential customers of
          Heights Finance. We do not knowingly collect personal information from children under 13.
          If we learn that we have collected the information of a child under 13, we will delete the
          information as soon as possible.
        </p>
        <p className={styles.contentSubtitle}>Changes to this Online Privacy Policy</p>
        <p>
          We reserve the right to modify or supplement this Online Privacy Policy at any time
          without notice. Your use of the Site after an update to the Online Privacy Policy means
          that you accept the new Online Privacy Policy. We will post the last updated date of any
          change at the bottom of our Online Privacy Policy. We encourage you to visit our Site
          regularly so that you remain aware of how our Online Privacy Policy may affect you.
        </p>
        <p className={styles.contentSubtitle}>
          Instructions to Opt Out of Disclosures to Nonaffiliated Third Parties
        </p>
        <p>
          To opt out of Heights Finance’s right to disclose your nonpublic personal information to
          nonaffiliated third parties, please review our {privacyNoticeLink('Privacy Notice')} and
          follow the instructions provided on the form.
        </p>
        <p className={styles.contentSubtitle}>International Users</p>
        <p>
          This Site is intended for the use by actual and potential customers within the United
          States of America.
        </p>
        <p className={styles.contentSubtitle}>No Contract Created</p>
        <p>
          This Online Privacy Policy is not a contract and is not intended to be a contract between
          customers or visitors, and Heights Finance with respect to any information practices
          concerning information obtained through use of this Site.
        </p>
        <p className={styles.contentSubtitle}>Questions?</p>
        <p>
          If you have any questions or comments regarding this Online Privacy Policy, please contact
          us at <a href={'tel: +1-866-413-1836'}>1-866-413-1836</a>.
        </p>
        <p>Last Updated 10/25/2024</p>
      </div>
    );
  };

  return (
    <ContentWithBackButton title="Online Privacy Policy">{renderContent()}</ContentWithBackButton>
  );
};

export default OnlinePrivacyPolicy;
